import { Component, Input } from '@angular/core';
import { CommonModule, NgStyle } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [CommonModule, NgStyle],
  template: `
    <div
      class="skeleton-wrapper"
      [ngStyle]="style"
      *ngFor="let _ of skeletonArray()"
    >
      <div class="shimmer-layer"></div>
    </div>
  `,
  styles: [
    `
      .skeleton-wrapper {
        position: relative;
        overflow: hidden;
        background-color: #f1f2f7;
        height: 0.65rem;
        margin-bottom: 1.1rem;
      }

      .shimmer-layer {
        position: absolute;
        inset: 0;
        width: 100%;
        background-image: linear-gradient(
          90deg,
          transparent,
          #e6e7ed,
          transparent
        );
        animation: shimmer 1.6s infinite;
        transform: translateX(-100%);
        border-radius: 0.3rem;
      }

      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }
    `,
  ],
})
export class SkeletonComponent {
  @Input() style: { [key: string]: any } = {};
  @Input() times: number = 1;

  protected skeletonArray(): Array<number> {
    return Array.from({ length: this.times }, (_, i) => i);
  }
}
